import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Home2 from "./pages/Home2";
import Servizio from "./pages/Servizio";
import Grazie from "./pages/Grazie";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import { CookieBanner } from "./components/CookieBanner";
import { getConsent, initPixel, captureAttribution, track } from "./lib/tracking";

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("PageView", { page: location.pathname });
  }, [location.pathname]);
  return null;
};

function App() {
  useEffect(() => {
    captureAttribution();
    const consent = getConsent();
    if (consent && consent.marketing) initPixel();

    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/2" element={<Home2 />} />
          <Route path="/servizio" element={<Servizio />} />
          <Route path="/grazie" element={<Grazie />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
